import { createContext } from 'react';

export const ActiveElementsContext = createContext(null);
